// extracted by mini-css-extract-plugin
module.exports = {"profileDetails":"Messaging_profileDetails__2DH8y","sidebarProfile":"Messaging_sidebarProfile__2xHNj","container":"Messaging_container__2NpPl"};